import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const isThenable = target => !!target && typeof target === 'object' && 'then' in target && typeof target.then === 'function';
function getTarget(container) {
  return typeof container === 'function' ? container() : container || null;
}
const rethrow = error => {
  setTimeout(() => {
    throw error;
  }, 0);
};
export const Portal = ({
  container,
  children
}) => {
  const [mountNode, setMountNode] = useState(null);
  useEffect(() => {
    const target = getTarget(container);
    if (isThenable(target)) {
      target.then(setMountNode).catch(rethrow);
    } else {
      setMountNode(target);
    }
  }, [container]);
  if (!mountNode) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/createPortal(children, mountNode)
  });
};